import {
  RESET_MODAL,
  SET_MODAL_CHILD,
  SET_MODAL_STATE,
  SET_MODAL_BUTTON_CLOSE,
} from "../actions/modalAction";

const initialState: ModalReducerState = {
  isOpen: false,
  child: null,
  idfor: "",
};
//ModalReducer
const modalReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_MODAL_STATE:
      return {
        ...state,
        isOpen: action.value,
      };
    case SET_MODAL_CHILD:
      return {
        ...state,
        child: action.value,
      };
    case SET_MODAL_BUTTON_CLOSE:
      return {
      ...state,
        idfor: action.value,
      };
    case RESET_MODAL:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export interface ModalReducerState {
  isOpen: boolean;
  child: any;
  idfor:string;
}

export default modalReducer;
